// import axios from "axios"
// import { resolve } from "core-js/fn/promise"
// import { map } from "core-js/core/array"
import api from "../api"

// Async functions to get data from DB API can also be synchronous (dispatch)

const actions = {
    async fetchReferentialList({ commit/* , state  */}) {
        try {
            const { data } = await api.get(`/referentiel`)
            commit("referentialMutation", data)
            //console.log("we got some project status ", state.projectStatusByReferential)
            return data
        } catch (error) {
            console.error("Error fetching referential:", error)
            throw error.response?.data
        }
    },
    async fetchReferentialsProduction({ commit }) {
        try {
            const { data } = await api.get(`/referentiel`)
            // //console.log("we got some data", data)
            commit("referentialProductionMutation", data)
        }
        catch (error) {
            console.error("Error fetching referential:", error)
            throw error.response?.data
        }
    },
    async fetchCriteriaListFromReferential({ commit}, { id }) {
        try {
            const { data } = await api.get(`/referentiel/${id}/criteria`)
            // //console.log("Data from criteria fetch: ", data)
            /* //console.log(data.criteria)
            //console.log(data.questions) */
            if (data?.criteria && Array.isArray(data.criteria)) {
                if(data.criteria.length > 0) {
                    // //console.log("tests passed, should load loadtreeMutation with values")
                    commit("loadTreeMutation", data.criteria)
                    //dispatch("projectStatus", {id})
                } else {
                    commit("loadTreeMutation", [])
                }
            } else {
                //console.log("No data in there")
                commit("loadTreeMutation", [])
            }
            if (data?.questions && Array.isArray(data.questions)) {
                if(data.questions.length > 0) {
                    // //console.log("tests passed, should load loadtreeMutation with values")
                    commit("loadTreeQuestionMutation", data.questions)
                } else {
                    commit("loadTreeQuestionMutation", [])
                }
            } else {
                // //console.log("No data in there");
                commit("loadTreeQuestionMutation", [])
            }
            commit("selectTreeMutation", id)
            return data // Return data directly instead of using resolve
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },    
    async referentialInsert({ dispatch }, {title, description, site, show_graphs}) {
        // //console.log("title and description sent: ", title, description)
        try {
            const { data } = await api.post(`/referentiel`, {
                title: title,
                description: description,
                status: "EDIT",
                show_graphs: show_graphs,
                site: site
            })
            // //console.log("we got some data, like this:", data)
            let id = data.referentiel_id
            dispatch("fetchReferentialList", null)
            dispatch("fetchCriteriaListFromReferential", {id})
            return data
        } catch(error) {
            console.error("Error inserting new referential:", error)
            throw error.response?.data
        }
    },
    async referentialDuplicate({ dispatch, commit }, { id, router }) {
        //console.log("id sent: ", id)
        try {
            const { data } = await api.post(`/referentiel/${id}/duplicate`)
            // //console.log("we got some data, like this:", data)
            let newId = data.referentiel_id
            commit("selectTreeMutation", newId)
            // //console.log("new id", newId)
            dispatch("fetchReferentialList", null)
            router.push(`/referential/${newId}`)
            return data
        } catch (error) {
            console.error("Error duplicating referential:", error)
            throw error.response?.data
        }
    },
    async referentialUpdate({ state, dispatch }, {id, title, description, site, status, show_graphs}) {
        // //console.log("state", state.selectedReferential)
        // //console.log("title, description and status sent: ", title, description, status)
        let editId = 0
        if(id) {
            editId = id
            //console.log("id sent: ", id)
        } else {
            // //console.log("id not sent, using selectedReferential", state.selectedReferential)
            editId = state.selectedReferential       
        }
        try {
            const { data } = await api.put(`/referentiel/${editId}`, {
                title: title,
                description: description,
                status: status,
                show_graphs:show_graphs,
                site: site
            })
            // //console.log("we got some data, like this:", data)
            let id = data.referentiel_id
            dispatch("fetchReferentialList", null)
            dispatch("fetchCriteriaListFromReferential", {id})
            return data
        } catch(error) {
            console.error("Error editing referential:", error)
            throw error.response?.data
        }
    },
    async referentialDelete({ state, dispatch, commit }, { id }) {
        // //console.log("We have following status to delete ", state.selectedReferential, id)
        if( state.selectedReferential == id ) {
            try {
                const { data } = await api.delete(`/referentiel/${state.selectedReferential}`)
                // //console.log("data return", data)
                if(data.result == true) {
                    dispatch("fetchReferentialList", null)
                    commit("selectTreeMutation", 0)
                }
                return data
            } catch(error) {
                console.error("Error deleting referential:", error)
                throw error.response?.data
            }
        } else {
            return false
        }
    },
    async referentialChangeStatus({ state, commit }, { id, status }) {
        // //console.log("We have following status to change ", state.selectedReferential, id, status)
        if( state.selectedReferential == id ) {
            try {
                const { data } = await api.put(`/referentiel/${state.selectedReferential}`, {
                    status: status
                })
                //console.log("data return", data)
                // if(data.result == true) {
                    // dispatch("fetchReferentialList", null)
                    // dispatch("fetchCriteriaListFromReferential", {id})
                    commit("updateReferentialStatusMutation", { id, status })
                    // //console.log("we did indeed change the status?", state.referentialData)
                // }
                return data
            } catch(error) {
                console.error("Error changing referential status:", error)
                throw error.response?.data
            }
        } else {
            return false
        }
    },
    async criteriaInsert({ commit, state }, {parent_id, title, reference, order_number}) {
        // //console.log("title and description sent: ", parent_id, title, reference, order_number)
        try {
            //commit("loadingMutation", true)
            const { data } = await api.post(`/criteria`, {
                parent: parent_id,
                title: title,
                reference: reference,
                //modifier order_number pour qu'il ne donne pas 0 (car actuellement c'est le cas)
                order_number: order_number,
                referential_id: state.selectedReferential,
            })
            // //console.log("we got some data, like this:", data)
            commit("addCriteriaMutation", data)
            //commit("loadingMutation", false)
            return data
        } catch(error) {
            console.error("Error inserting new criteria:", error)
            throw error.response?.data
        }
    },
    async criteriaUpdate({ state, commit }, {parent_id, title, reference, order_number}) {
        // //console.log("state", state.activeCriteria)
        // //console.log("title and description sent: ", parent_id, title, reference, order_number)
        try {
            //commit("loadingMutation", true)
            const { data } = await api.put(`/criteria/${state.activeCriteria.id}`, {
                parent: parent_id,
                title: title,
                reference: reference,
                order_number: order_number,
                referential_id: state.selectedReferential,
            })
            //commit("loadingMutation", false)
            // //console.log("we got some data, like this:", data)
            commit("updateCriteriaMutation", {id: state.activeCriteria.id, updatedData: data})
            return data
        } catch(error) {
            console.error("Error editing Criteria:", error)
            throw error.response?.data
        }
    },
    async criteriaDelete({ commit, state }, { id }) {
        try {
            const { data } = await api.delete(`/criteria/${id}/${state.selectedReferential}`)
            // //console.log("data return", data)
            if(data.result == true) {
                // //console.log("we did indeed delele a criteria")
                commit("removeCriteriaMutation", id)
            } else {
                // //console.log("Failed deleting why though?")
            }
            return data
        } catch(error) {
            console.error("Error deleting Criteria:", error)
            throw error.response?.data
        }
    },
    async questionInsert({ commit, dispatch }, {criteria_id, help_text, description, documentation, question_type, question_values, justification, /* mandatory, */ is_evaluated, question_limits, tag, evaluated_by_formula}) {
        // //console.log("question data received: ", criteria_id, help_text, description, documentation, question_type, question_values, justification, mandatory, is_evaluated, question_limits, tag, evaluated_by_formula)
        const questionValuesSend = new Map()
        if(question_values) {
            for (let i = 0; i < question_values.length; i++) {
                let possibleText = ""
                if(question_values[i].selected) {
                    switch(i) {
                        case 0: possibleText = "Black"; break;
                        case 1: possibleText = "Red"; break;
                        case 2: possibleText = "Orange"; break;
                        case 3: possibleText = "Green"; break;
                    }
                    questionValuesSend.set(i, {
                        meaning: question_values[i].text,
                        possible_text: possibleText,
                    })
                }
            }
        }
        try {
            const { data } = await api.post(`/question`, {
                criteria_id: criteria_id,
                help_text: help_text,
                description: description,
                documentation: documentation,
                justification: justification,
                question_type: question_type,
                question_values: Object.fromEntries(questionValuesSend),
                question_limits: question_limits,
                //mandatory: mandatory,
                is_evaluated: is_evaluated,
                tag: tag,
                evaluated_by_formula: evaluated_by_formula,
            })
            // //console.log("we got some data, like this:", data)
            commit("addQuestionMutation", data)
            dispatch("fetchReferentialList", null)
            return data
        } catch(error) {
            console.error("Error inserting new question:", error)
            throw error.response?.data
        }
    },
    async questionUpdate({ state, commit, dispatch }, {criteria_id, help_text, description, documentation, question_type, question_values, justification, question_limits, /* mandatory, */ is_evaluated, tag, evaluated_by_formula}) {   
        // //console.log("state", state.activeQuestion)
        // //console.log("limits", state.activeQuestion.question_limit)
        // //console.log("question data received: ", criteria_id, help_text, description, documentation, question_type, question_values, justification, question_limits, mandatory, is_evaluated, tag, evaluated_by_formula)
        const questionValuesSend = new Map()
        if(question_values) {
            for (let i = 0; i < question_values.length; i++) {
                let possibleText = ""
                if(question_values[i].selected) {
                    switch(i) {
                        case 0: possibleText = "Black"; break;
                        case 1: possibleText = "Red"; break;
                        case 2: possibleText = "Orange"; break;
                        case 3: possibleText = "Green"; break;
                    }
                    questionValuesSend.set(i, {
                        meaning: question_values[i].text,
                        possible_text: possibleText,
                    })
                }
            }
        }
        try {
            const { data } = await api.put(`/question/${state.activeQuestion.id}`, {
                criteria_id: criteria_id,
                help_text: help_text,
                description: description,
                documentation: documentation,
                justification: justification,
                question_type: question_type,
                question_values: Object.fromEntries(questionValuesSend),
                question_limits: question_limits,
                //mandatory: mandatory,
                is_evaluated: is_evaluated,
                tag: tag,
                evaluated_by_formula: evaluated_by_formula
            })
            // //console.log("we got some data, like this:", data)
            commit("updateQuestionMutation", {id: state.activeQuestion.id, updatedData: data})
            commit("makeQuestionActiveMutation", data)
            dispatch("fetchReferentialList", null)
            return data
        } catch(error) {
            console.error("Error editing question:", error)
            throw error.response?.data
        }
    },
    async questionDelete({ commit }, { id }) {
        // //console.log("We have following question to delete ", id)
        // if( state.activeQuestion == id ) {
            try {
                const { data } = await api.delete(`/question/${id}`)
                // //console.log("data return", data)
                if(data.result == true) {
                //    //console.log("Deleting question successful")
                   commit("removeQuestionMutation", id)
                }
                return data
            } catch(error) {
                console.error("Error deleting referential:", error)
                throw error.response?.data
            }
        // } else {
        //     return false
        // }
    },

    
    async fetchReferentialDatabase({ commit }, { id }) {
        try {
            const { data } = await api.get(`/referentiel/${id}/database`)
            // //console.log("Data from referential database fetch: ", data)
            if (Array.isArray(data)) {
                if(data.length > 0) {
                    // //console.log("tests passed, should load loadtreeMutation with values")
                    commit("loadTreeDatabaseMutation", data)
                } else {
                    commit("loadTreeDatabaseMutation", [])
                }
            } else {
                // //console.log("No data in there")
                commit("loadTreeDatabaseMutation", [])
            }
            return data // Return data directly instead of using resolve
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async updateReferentialDatabase({ state, commit }, { index, database, type, value, tag}) {
        // //console.log("Data from referential database fetch: ", database)
        try {
            // //console.log("type selected: ", type)
            if(type == "single") {
                const { data } = await api.put(`/referentiel/${state.selectedReferential}/database/${database.tag}`, {
                    value: value,
                })
                //console.log("[updateReferentialDatabase] => we got some data, like this 'single':", data, data.value)
                commit("updateReferentialSingleValueMutation", { tag: tag || data.tag, value:data.value, index: index })
                return data
            } else if(type == "array") {
                const { data } = await api.put(`/referentiel/${state.selectedReferential}/database/${database.tag}`, {
                    values: database.values,
                })
                //console.log("[updateReferentialDatabase] => we got some data, like this 'array':", state.referentialDatabase)
                commit("updateDatabaseMutation", { index: index, updatedData: data })
                return data
            }
            
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async getGeneralDataConfig({ commit, state }) { 
        try {
            const { data } = await api.get(`/referentiel/${state.selectedReferential || state.selectedProject}/project_variables`)
            //console.log("Data from referential database fetch: ", data)
            if (Array.isArray(data)) {
                if(data.length > 0) {
                    // //console.log("tests passed, should load loadtreeMutation with values")
                    commit("generalDataConfigMutation", data)
                } else {
                    commit("generalDataConfigMutation", [])
                }
            } else {
                // //console.log("No data in there")
                commit("generalDataConfigMutation", [])
            }
            return data // Return data directly instead of using resolve
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async updateGeneralDataConfig({ state, commit }, { tag, is_visible }) {
        //console.log("Data from referential database fetch: ", is_visible)
        try {
            const { data } = await api.put(`/referentiel/${state.selectedReferential || state.selectedProject}/project_variables/${tag}`, {
                is_visible: is_visible,
            })
            commit("updateDatabaseMutation", { is_visible: is_visible })
            return data // Return data directly instead of using resolve
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data 
        }
    },
    async fetchQuestionTags({ state, commit }) {
        try {
            const { data } = await api.get(`/referentiel/${state.selectedReferential}/parameters/forcriteria`)
            // const { data } = await api.get(`/referentiel/${state.selectedReferential}/parameters/forevaluation`)
            ////console.log("Data from question tags fetch: ", data)
            if (Array.isArray(data)) {
                if(data.length > 0) {
                    commit("questionTagsMutation", data)
                } else {
                    commit("questionTagsMutation", [])
                }
            } else {
                // //console.log("No data in there")
                commit("questionTagsMutation", [])
            }
            return data // Return data directly instead of using resolve
        }
        catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async fetchEvaluationTags({ commit, state }) {
        try {
            // const { data } = await api.get(`/${state.selectedReferential}/parameters/forcriteria`)
            const { data } = await api.get(`/referentiel/${state.selectedReferential}/parameters/forevaluation`)
            // //console.log("Data from evaluation tags fetch: ", data)
            if (Array.isArray(data)) {
                if(data.length > 0) {
                    commit("evaluationTagsMutation", data)
                } else {
                    commit("evaluationTagsMutation", [])
                }
            } else {
                // //console.log("No data in there")
                commit("evaluationTagsMutation", [])
            }
            return data
        }
        catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async fetchUsersOnly({ commit }) {
        try {
            const { data } = await api.get(`/user/list`)
            // //console.log("we got some data", data)
            commit("userListMutation", data)
            return data
        } catch (error) {
            console.error("Error fetching userList:", error)
            throw error.response?.data
        }
    },
    async fetchUserList({ commit, state }, { id }) {
        try {
            const { data } = await api.get(`/user/list`)
            const { data: data2 } = await api.get(`/referentiel/${state.selectedReferential}/users`)
            // //console.log("we got some data", data)
            // //console.log("we got some data2", data2)
            commit("userListMutation", data, id)
            commit("userListRightsReferentialMutation", data2, id)
            return data
        } catch (error) {
            console.error("Error fetching Users for referential:", error)
            throw error.response?.data
        }
    },
    async toggleUserAccess({ commit, state }, { user, referential_id, type, checked }) {
        // //console.log("user data received: ", user, referential_id, type, checked)
        if(state.selectedReferential == referential_id) {
            try {
                if(checked) {
                    const { data } = await api.put(`/referentiel/${state.selectedReferential}/grant/${user.user_id}`, {
                        role: type
                    })
                    if(data.success == true) {
                        //console.log("which user access 1 ", user, checked)
                        commit("updateUserAccessMutation", { user, type, checked })
                    } else {
                        // //console.log("Failed to grant access")
                    }
                    return data
                }
                else {
                    const { data } = await api.put(`/referentiel/${state.selectedReferential}/revoke/${user.user_id}`, {
                        role: type
                    })
                    if(data.success == true) {
                        //console.log("which user access 2 ", user, checked)
                        commit("updateUserAccessMutation", { user, type, checked })
                    }
                    return data
                }
            } catch (error) {
                console.error("Error changing user access:", error)
                throw error.response?.data
            }
        }
    },
    async toggleProjectAccess({ commit, state }, { user, project_id, type, checked }) {
        // //console.log("user data received: ", user, project_id, type, checked)
        if(type == "PE") {
          try {
            if(checked) {
                    // const { data } = await api.put(`/project/${project_id}/grant/${user.user_id}`, {
                    //     role: type
                    // })
                    const { data } = await api.put(`/referentiel/${state.selectedReferential}/grant-project/${project_id}/${user.user_id}`, {
                        role: type
                    })
                    if(data.success == true) {
                        commit("updateUserAccessProjectMutation", { user, type, checked })
                        // //console.log("User access granted successfully", user, type, checked)
                    } else {
                        // //console.log("Failed to grant access")
                    }
                    return data
                }
                else {
                    // const { data } = await api.put(`/project/${project_id}/revoke/${user.user_id}`, {
                    //     role: type
                    // })
                    const { data } = await api.put(`/referentiel/${state.selectedReferential}/revoke-project/${project_id}/${user.user_id}`, {
                        role: type
                    })
                    if(data.success == true) {
                        commit("updateUserAccessProjectMutation", { user, type, checked })
                        // //console.log("User access revoked successfully", user, type, checked)
                    } else {
                        // //console.log("Failed to revoke access with following values", user, type, checked)
                    }
                    return data
                }
          } catch (error) {
            console.error("Error changing user access:", error)
            throw error.response?.data
          }
        }
    },
    async toggleAdminAccess({ commit }, { user, checked }) {
        // //console.log("user data received: ", user, checked)
        try {
            if(checked) {
                const { data } = await api.put(`/user/admin-grant/${user.user_id}`, {
                    checked: checked
                })
                if(data.success == true) {
                    commit("updateUserAccessMutation", { user, type: 'admin', checked })
                } else {
                    // //console.log("Failed to grant access")
                }
                return data
            }
            else {
                const { data } = await api.put(`/user/admin-revoke/${user.user_id}`, {
                    checked: checked
                })
                if(data.success == true) {
                    commit("updateUserAccessMutation", { user, type: 'admin', checked })
                }
                return data
            }
        } catch (error) {
            console.error("Error changing user access:", error)
            throw error.response?.data
        }
    },
    async unlockReferential({ commit, state, dispatch }, { id }) {
        // //console.log("We have following referential to unlock ", state.selectedReferential, id)
        if( state.selectedReferential == id ) {
            try {
                const { data } = await api.put(`/referentiel/${state.selectedReferential}/unlock`)
                // //console.log("data return", data)
                commit("unlockStatus", data.result)
                dispatch("fetchReferentialList", null)
                return data
            } catch(error) {
                console.error("Error unlocking referential:", error)
                throw error.response?.data
            }
        } else {
            return false
        }
    },
    async projectStatus({ commit/* , getters, rootState  */}, { id }){
        if (!id || id === 0) return;

     /*    if (rootState.referential.projectStatusByReferential[id]) {
            return; 
        }

        const referential = getters.fetchReferential(id);
        const isAdmin = rootState.auth.isAdmin;

        if (!referential || (!referential.RC && !isAdmin)) {
            commit("projectStatusMutation", { referential_id: id, statusData: [] });
            return;
        }
         */
        try {
            const { data } = await api.get(`/referentiel/${id}/projects`);
            commit("projectStatusMutation", { referential_id: id, statusData: data });
            return data;
        } catch (error) {
            console.error("Error fetching project status for id:", id, error);
            commit("projectStatusMutation", { referential_id: id, statusData: [] });
            throw error.response?.data;
        }
    },
    async referentialValidate({ commit }, {id}){
        const { data } = await api.get(`referentiel/${id}/validate`)
        try{
            //console.log("we got some data", data)
            commit("referentialValidateMutation", data)
            return data
        }catch(error){
            console.error("Error validating referential:", error)
        }
    },
    async fetchValidatorList({ state, commit }, { id }) {
        try {
            //console.log("Fetching validator list for project ID:", id, "and referential ID:", state.selectedReferential)
            // const { data } = await api.get(`/project/${id}/users`)
            const { data } = await api.get(`/referentiel/${state.selectedReferential}/project-users/${id}`)
            //console.log("we got some data in fetchValidatorList", data)
            commit("validatorListMutation", data)
            return data
        } catch (error) {
            console.error("Error fetching validator list:", error)
            throw error.response?.data
        }
    },
    async createReportPDF({state, commit}, id){
        const projectId = id ? id : state.selectedProject
        if (!projectId) return;
        try{
            const { data } = await api.post(`referentiel/${projectId}/report`, null, {
                responseType: 'blob'
            })
            //console.log("Report = ", data);
            commit("createPDFMutation", data)
            return data;
        }catch(error){
            console.error("fetching pdf went wrong: ", error)
            throw error.response?.data;
        }
    }, 
    async flushProjects(_, payload){
        const id = payload.id
        //console.log("flushing all projects as a ReferentialCreator, id ", id)
        try{
            const {data} = await api.post(`/referentiel/${id}/flush`, id)
            //console.log("flushing all projects as a ReferentialCreator", data)
            return data;
        }catch(error){
            console.error("Error flushing projects :", error)
            throw error.response?.data;
        }
    }
}

export default actions;